import { Button, Icon } from "@elit-hair/elit-ui";
import { IconType } from "react-icons";
import { TbWorld } from "react-icons/tb";

import { cn } from "@/lib/utils";

import { PRESET_ICONS } from "./icons";

type IconSelectorProps = {
    selectedIcon?: string | null;
    onSelect: (iconName: string) => void;
    className?: string;
    icons?: Array<{ name: string; component: IconType }>;
    faviconOption?: {
        label: string;
        selected: boolean;
        onSelect: () => void;
    };
};

export const IconSelector = ({
    selectedIcon,
    onSelect,
    className,
    icons = PRESET_ICONS,
    faviconOption,
}: IconSelectorProps) => {
    return (
        <div className={cn("space-y-3", className)}>
            <div className="max-h-[200px] overflow-y-auto p-1">
                <div className="grid grid-cols-8 gap-2">
                    {faviconOption ? (
                        <Button
                            type="button"
                            onClick={faviconOption.onSelect}
                            variant="outline"
                            size="icon"
                            className={cn(
                                "border-2 transition-colors",
                                faviconOption.selected &&
                                    "border-primary bg-primary/10 ring-2 ring-primary text-primary"
                            )}
                            title={faviconOption.label}
                            aria-label={faviconOption.label}
                            aria-pressed={faviconOption.selected}
                        >
                            <Icon icon={TbWorld} />
                        </Button>
                    ) : null}
                    {icons.map((icon) => {
                        const isSelected = selectedIcon === icon.name;
                        return (
                            <Button
                                key={icon.name}
                                onClick={() => onSelect(icon.name)}
                                variant="outline"
                                size="icon"
                                className={cn(
                                    "border-2 transition-colors",
                                    isSelected && "border-primary bg-primary/10 ring-2 ring-primary text-primary"
                                )}
                                title={icon.name}
                                aria-pressed={isSelected}
                            >
                                <Icon icon={icon.component} />
                            </Button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
